import {Outlet} from 'react-router-dom'
import './Layout.css'

const LoginLayout = () => {
  return (
    <div className="layout" style={{ height: '100vh', width: '100vw' }}>
      <main className="main">
        <Outlet />
      </main>
    </div>
  )
}

export default LoginLayout
